export default class HeaderModule {
    constructor() {
        this.STATES = {
            OPEN:  'open',
            CLOSE: 'close'
        };

        this.current_state = this.STATES.CLOSE;
    }

    get isOpen() {
        return ( this.current_state === this.STATES.OPEN );
    }
}
